/**
 * 탭 프리셋 — MUI Tabs/Tab 조합.
 * 사용처: root(재무/HR 등 페이지 탭), compact(결재 패널), channel(채널 탭).
 * indicator height 를 키우면 선택선이 두꺼워지고, minHeight 를 줄이면 탭 영역이 컴팩트해진다.
 */
export const createTabsPresets = (tokens) => ({
    // 일반 페이지 탭 — HR/재무/결재 등 페이지 상단 큰 탭.
    root: {
        "& .MuiTab-root": {
            fontSize: 15,              // 페이지 탭은 크게 — 화면의 1차 내비게이션이므로
            fontWeight: 550,           // 중간 굵기 — 선택 탭은 muiTheme(MuiTab)에서 primary 색으로 강조
            textTransform: "none",     // 영문 라벨 자동 대문자화 방지
            minHeight: 40,             // 탭 하나의 높이
        },
        "& .MuiTabs-indicator": {
            bgcolor: tokens.colors.primary,      // 선택 밑줄 색 = 브랜드 프라이머리
            height: 2.5,                         // 밑줄 두께
            borderRadius: "1px 1px 0 0",         // 밑줄 윗모서리만 살짝 둥글게
        },
        minHeight: 40,                 // 탭 바 전체 높이 (Tab 과 맞춰야 세로 정렬이 맞음)
    },

    // 컴팩트 탭 — 결재 패널처럼 좁은 영역 안에 들어가는 탭.
    compact: {
        minHeight: 45,
        "& .MuiTab-root": {
            minHeight: 36,             // root(40)보다 낮게
            fontSize: 14,              // 좁은 영역이므로 글자도 축소
            textTransform: "none",
            fontWeight: 600,
            px: 0.5,                   // 좌우 여백 최소화 — 탭 여러 개를 좁게 배치
        },
        "& .MuiTabs-indicator": {
            bgcolor: tokens.colors.primary,
        },
    },

    // 채널 탭 — 탭 수가 많고 가로 공간이 중요한 채널 화면 전용.
    channel: {
        "& .MuiTab-root": {
            fontSize: 14,
            fontWeight: 600,
            textTransform: "none",
            minWidth: 56,              // 탭 최소 폭 — 짧은 채널명도 클릭 영역 확보
            px: 1.5,
        },
        "& .MuiTabs-indicator": {
            height: 3,                 // 채널 탭은 밑줄을 조금 더 두껍게
            borderRadius: "3px 3px 0 0",
        },
    },
});
